import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

class Modal extends Component {
  constructor(props) {
    super(props);

    this.escFunction = this.escFunction.bind(this);

    this.state = {};
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction);
  }

  escFunction(e) {
    if (e.keyCode === 27) {
      e.preventDefault();
      this.context.router.history.goBack();
    }
  }

  render() {
    let className = 'modal';

    if (this.props.light) className += ' modal--light';
    if (this.props.small) className += ' modal--small';
    if (this.props.large) className += ' modal--large';

    return (
      <div className={className}>
        <div className="modal__header">
          <div className="modal__left">
            {this.props.leftButton}
          </div>
          <div className="modal__middle">
            <h1 className="modal__title">{this.props.title}</h1>
          </div>
          <div className="modal__right">
            {this.props.rightButton}
          </div>
        </div>
        <div className="modal__body">
          {this.props.children}
        </div>
      </div>
    );
  }
}

Modal.contextTypes = {
  router: PropTypes.object,
};

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  light: PropTypes.bool,
  small: PropTypes.bool,
  large: PropTypes.bool,
  leftButton: PropTypes.element,
  rightButton: PropTypes.element,
};

Modal.defaultProps = {
  light: false,
  small: false,
  large: false,
  leftButton: null,
  rightButton: null,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.jsx